<div
  (click)="onClick($event)"
  (keydown.enter)="onEnter($event)"
  class="overlay"
>
  @if (!isLoading) {
    <div class="overlay__header"></div>
    <div class="overlay__aside"></div>
    <div class="overlay__content"></div>
  }
  @if (isLoading) {
    <div class="overlay__loading">
      <div class="overlay__loading-body">
        @if (loadingType === overlayService.loadingType.GIF) {
          <div>
            <img
              [src]="loadingGifSrc"
              class="overlay__loading-gif"
            />
          </div>
        }
        @if (loadingType === overlayService.loadingType.SPINNER) {
          <qima-spinner
            [qimaSpinnerSize]="150"
            [qimaSpinnerUnit]="spinnerService.unit.PIXEL"
            [style.color]="qimaColor.pool.POOL_500"
          ></qima-spinner>
        }
        @if (loadingType === overlayService.loadingType.THREE_SQUARES) {
          <qima-three-squares-loader
            [qimaThreeSquaresLoaderSize]="120"
            [qimaThreeSquaresLoaderStyle]="threeSquaresLoaderService.style.POOL_500"
            [qimaThreeSquaresLoaderUnit]="threeSquaresLoaderService.unit.PIXEL"
          ></qima-three-squares-loader>
        }
        @if (overlayLoadingText) {
          <div class="overlay__loading-text">
            {{ overlayLoadingText | translate }}
          </div>
        }
      </div>
    </div>
  }
</div>
